'use client';

import { useEffect, useState } from 'react';
import { CelebrityGrid } from '@/components/celebrities/CelebrityGrid';
import { Footer } from '@/components/Footer';
import { Celebrity } from '@/data/celebrities';

export default function CelebritiesContent() {
  const [celebrities, setCelebrities] = useState<Celebrity[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function loadCelebrities() {
      try {
        const data = (await import('../../../public/data/celebrities.json')).default;
        setCelebrities(data);
      } catch (error) {
        console.error('Error loading celebrities:', error);
      } finally {
        setLoading(false);
      }
    }

    loadCelebrities();
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="w-16 h-16 border-4 border-blue-600 border-t-transparent rounded-full animate-spin mx-auto"></div>
          <p className="mt-4 text-gray-600">Loading celebrities...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="container mx-auto px-4 py-8">
        <h1 className="text-4xl font-bold text-center mb-8">Celebrity Beauty Scores</h1>
        <p className="text-gray-600 text-center mb-12 max-w-2xl mx-auto">
          Discover how our AI rates the attractiveness of famous celebrities. Compare your own score with these celebrities and see where you stand!
        </p>
        
        <CelebrityGrid celebrities={celebrities} />
        
        <div className="mt-8 text-sm text-gray-500">
          <p>
            Images source: Wikipedia - CC BY-SA 3.0 License
          </p>
          <p>
            Scores are generated by our AI system and are for reference only.
            All rights belong to their respective owners.
          </p>
        </div>
      </div>
      <Footer />
    </div>
  );
}
